import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Typography, Button, FormError } from "components";
import { Formik, Form, ErrorMessage } from "formik";
import { ROUTES, pocketMoniUrl } from "routes/routePaths";
import { routes } from "routes/apiRoutes";
import makeRequest from "services/makeRequest";
import { ninValidation } from "utils/validators";
import AuthHeader from "./AuthHeader";
import resetImage from "assets/images/reset-image.png";
import pmLogo from "assets/images/pocketmoni-logo.png";
import * as Yup from "yup";
import "./style.scss";
import { useSelector, useDispatch } from "react-redux";
import { SET_USER } from "redux/types/user";
import { logOut } from "utils/helper";
import { isUserActive, setAlert, isAuthenticated } from "utils/helper";

const RequestNIN = () => {
  const navigate = useNavigate();
  const { dashboard, dashboardTerminalStats } = ROUTES;

  const dispatch = useDispatch();

  const [error, setError] = useState("");

  const { user } = useSelector((state) => state.user);

  const validationSchema = Yup.object({
    nin: ninValidation(),
  });

  const onSubmit = async ({ nin }) => {
    setError("");

    try {
      const { data } = await makeRequest("post", routes.submitNin(), {
        nin,
        userId: user?.user_id,
      });

      if (data.responseCode.toString() === "200") {
        setAlert("NIN Successfully submitted", "success");
        const routeToNavigate = isUserActive(user)
          ? dashboardTerminalStats
          : dashboard;

        let currentUser = JSON.parse(
          localStorage.getItem("current_user") || null
        );
        currentUser = { ...currentUser, nin };
        localStorage.setItem("current_user", JSON.stringify(currentUser));

        dispatch({
          type: SET_USER,
          payload: currentUser,
        });

        setTimeout(() => {
          navigate(routeToNavigate);
        }, 2000);
      } else {
        setAlert(data.responseMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user.nin) {
      navigate(-1);
    }

    //eslint-disable-next-line
  }, []);

  if (!isAuthenticated()) {
    logOut();

    return null;
  }

  return (
    <div className="row m-0 auth-container">
      <div className="auth-header-container">
        <AuthHeader isLogOutHeader />
      </div>

      <div className="col-12 col-xl-6 p-0 auth-form-container">
        <div className="login-form" style={{ maxWidth: "25rem" }}>
          <div className="auth-intro">
            <div className="mb-4 d-xl-none">
              <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
                <img src={pmLogo} width="150" alt="PocketMoni" />
              </a>{" "}
            </div>
            <Typography component="h3" variant="heading3" state="primary">
              NIN Request
            </Typography>
            <Typography variant="body3" state="primary">
              Please provide your NIN
            </Typography>
          </div>

          <Formik
            initialValues={{
              nin: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => await onSubmit(values)}
          >
            {({ errors, touched, getFieldProps, isSubmitting }) => (
              <Form noValidate autoComplete="off">
                {error && (
                  <Typography
                    state="danger"
                    variant="body2"
                    className="text-center"
                  >
                    {error}
                  </Typography>
                )}

                <div className="mb-4">
                  <TextField
                    name="nin"
                    type="number"
                    placeholder="Enter NIN"
                    // label="NIN"
                    {...getFieldProps("nin")}
                    hasError={errors.nin && touched.nin}
                  />
                  <ErrorMessage component={FormError} name="nin" />
                </div>

                <Button
                  type="submit"
                  label="Submit"
                  fullWidth
                  loading={isSubmitting}
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div
        className="d-none d-xl-block col-xl-6 p-0"
        style={{ height: "100vh!important" }}
      >
        <img src={resetImage} width="100%" height="100%" alt="Log In" />
      </div>
    </div>
  );
};

export default RequestNIN;
